import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import CodeBlock from './CodeBlock';

const MarkdownRenderer = ({ content }) => {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                a: ({ href, children }) => (
                    <a href={href} target="_blank" rel="noreferrer" className="underline opacity-90">
                        {children}
                    </a>
                ),
                code({ inline, className, children }) {
                    const match = /language-(\w+)/.exec(className || '');
                    const value = String(children).replace(/\n$/, '');
                    if (!inline) {
                        return <CodeBlock language={match?.[1]} value={value} />;
                    }
                    return (
                        <code className="rounded bg-black/10 px-1 py-0.5 text-[0.9em] dark:bg-white/10">
                            {children}
                        </code>
                    );
                },
                table: ({ children }) => (
                    <div className="my-3 overflow-x-auto">
                        <table className="min-w-full border-collapse text-sm">{children}</table>
                    </div>
                ),
                th: ({ children }) => (
                    <th className="border border-black/10 px-2 py-1 text-left dark:border-white/10">{children}</th>
                ),
                td: ({ children }) => (
                    <td className="border border-black/10 px-2 py-1 dark:border-white/10">{children}</td>
                ),
                blockquote: ({ children }) => (
                    <blockquote className="my-2 border-l-4 border-black/20 pl-3 opacity-80 dark:border-white/20">
                        {children}
                    </blockquote>
                ),
            }}
        >
            {content || ''}
        </ReactMarkdown>
    );
};

export default MarkdownRenderer;
